const getParam = (query) => {
    if (!query.s) {
        return [];
    }
    if (typeof query.s === 'string') {
        return [query.s];
    }
    return query.s;
};
export const getSplitConfig = (query) => {
    const reg = /\w*,\d$/;
    return getParam(query)
        .filter((value) => reg.test(value))
        .reduce((accumulator, value) => {
        const [key, value_] = value.split(',');
        return {
            ...accumulator,
            [key]: Number(value_),
        };
    }, {});
};
//# sourceMappingURL=utils.js.map